import React, { Suspense, useContext, useState } from "react";

import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component

import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import { useDeleteData, useFetchData } from "hooks/useApiHooks";
import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./components/create-page";
import { useDeleteHandler } from "hooks/useDeleteHandler";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { usePhotographer } from "contexts/v1/masterData/PhotographerContext";
// import { PhotographerCreateProvider } from "contexts/v1/masterData/PhotographerCreateContext";
import Swal from "sweetalert2";
import { deleteRequest } from "services/api";
import { LogPhotographerProvider } from "contexts/LogPhotographerContext";
import PhotographerHistoryPage from "./components/history";

// Main Photographer Page Component
const PhotographerPage = () => {
  const { photographers, refetch } = usePhotographer();
  // console.log("photographers", photographers);
  const [currentPage, setCurrentPage] = useState(1); // For pagination

  const { handleSuccess, handleError, showCanvasHandler, handleSuccessToast } =
    useCanvasHandler();

  const handleCreate = (e) => {
    e.preventDefault();
    showCanvasHandler(
      "Create Photographer",
      // <PhotographerCreateProvider>
      <CreatePage
        onSuccess={() => {
          handleSuccessToast(true, "Photographer creating");
          refetch();
        }}
        onError={handleError}
      />
      // </PhotographerCreateProvider>
    );
  };

  const handleUpdate = (e, data) => {
    e.preventDefault();
    showCanvasHandler(
      "Update Photographer",
      // <PhotographerCreateProvider>
      <CreatePage
        initialData={data}
        onSuccess={() => {
          handleSuccessToast(true, "Photographer updating");
          refetch();
        }}
        onError={handleError}
      />
      // </PhotographerCreateProvider>
    );
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteRequest(`/photographer/${id}`);

        if (response.success) {
          handleSuccessToast(true, "Photographer deleting");
          refetch();
        }
      }
    });
  };

  const totalPages = photographers.pagination?.last_page || 1;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  if (photographers.loading) return <FullLoader />;
  if (photographers.error) return <Suspense error={photographers.error} />;

  const handleHistory = (e, data) => {
    e.preventDefault();
    console.log(data);
    showCanvasHandler(
      "Photographer History",
      <LogPhotographerProvider>
        <PhotographerHistoryPage
          initialData={data}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      </LogPhotographerProvider>
    );
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        <div className="table-container ">
        <h1>PHOTOGRAPHER</h1>

          <div className="search-container mb-3">
            <SearchInput />

            <button className="btn btn-primary" onClick={handleCreate}>
              Create
            </button>
          </div>

          <div className="table table-responsive">
            <table className="table table-hover table-vcenter">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Photographer Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Note</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>
              {photographers.data.length > 0 && (
                <tbody>
                  {photographers.data.map((data, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.name}</td>
                        <td>{data.email}</td>
                        <td>{data.phone}</td>
                        <td>{data.note}</td>
                        <td className="text-end">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="default"
                              id="dropdownMenuButton1"
                            >
                              Actions
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleUpdate(e, data)}
                              >
                                Edit
                              </Dropdown.Item>
                              {/* history */}
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => handleHistory(e, data)}
                              >
                                History
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="#"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(data.id);
                                }}
                              >
                                Remove
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              )}
            </table>
          </div>

          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default PhotographerPage;

// Search Input Component
const SearchInput = () => {
  const { handleSearch, filterOptions } = usePhotographer();
  const [search, setSearch] = useState(filterOptions.search || "");

  return (
    <div className="input-icon">
      <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={handleSearch}
      />
      <span className="input-icon-addon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-search"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          strokeWidth="2"
          stroke="currentColor"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="10" cy="10" r="7" />
          <line x1="21" y1="21" x2="15" y2="15" />
        </svg>
      </span>
    </div>
  );
};
